import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";

import { storeService } from "../../services";
import {
  customToast,
  formatDate,
  isStripeSubscriptionActive,
  parseToThousandSeperatorDecimalNumber,
} from "../../shared/utility";
import Topbar from "../../shared/components/topbar/Topbar";
import Button from "../../shared/components/Buttons/Button";
import {
  buttonNameConstants,
  STORE_BILLING_STATUS,
  storeConstants,
  toastType,
} from "../../constants";
import PaymentMethods from "../../assets/images/paymentMethods.svg";
import { systemActions } from "../../redux/actions/system.action";

const Billing = ({ currentStore, activateSpinner, deactivateSpinner }) => {
  const billing = currentStore?.billing ?? {};
  const handleSubscriptionButtonClick = async () => {
    activateSpinner(storeConstants.SUBSCRIBE);
    await storeService.storeSubscriptionPayment(currentStore?.id).then(
      (response) => {
        window.location.replace(response);
      },
      (error) => {
        customToast(error, toastType.ERROR);
      }
    );
    deactivateSpinner(storeConstants.SUBSCRIBE);
  };
  const BillingStatusInfo = () => {
    const freeMonthsRemaining = (
      <>
        <br />
        Free Months Remaining:{" "}
        <strong> {billing.grantedFreeMonthsRemaining}</strong>
        <br />
      </>
    );
    const trialBillingInfo = (
      <>
        {" "}
        Trial Ends On: <strong>{formatDate(billing.trialEndDate, true)}</strong>
        First Charge On:{" "}
        <strong>
          {billing.stripeSubscriptionStartDate
            ? formatDate(billing.stripeSubscriptionStartDate, true)
            : "Not Subscribed yet"}
        </strong>
      </>
    );
    const activeSubscriptionBillingInfo = (
      <>
        Next Billing Date:{" "}
        <strong>{formatDate(billing.stripeNextChargeDate, true)}</strong>
      </>
    );
    const gracePeriodBillingInfo = (
      <>
        Payment Past Due:{" "}
        <strong>{formatDate(billing.paymentDueDate, true)}</strong>
        <br />
        <span className="color-red">
          Service will be interrupted if payment is not completed within{" "}
          {billing.remainingGracePeriodDays} day(s).
        </span>
      </>
    );
    const adminGrantedFreeMonthsBillingInfo = (
      <>
        Payment due on{" "}
        <strong>{formatDate(billing.paymentDueDate, true)}</strong>.
        {freeMonthsRemaining}
        <span>
          You’ve been granted complimentary access until{" "}
          <strong>{formatDate(billing.grantedFreeMonthsTill, true)}</strong>.
          Please complete your payment before this date to avoid any service
          interruption.
        </span>
      </>
    );
    const serviceSuspendedBillingInfo = (
      <>
        {billing.paymentDueDate && (
          <>
            Payment Past Due:
            <strong>{" " + formatDate(billing.paymentDueDate, true)}</strong>
          </>
        )}
        <br />
        <span>
          Your service has been suspended due to non-payment. Please complete
          payment to reactivate your account.
        </span>
      </>
    );

    return billing.storeBillingStatus === STORE_BILLING_STATUS.TRIAL ? (
      trialBillingInfo
    ) : isStripeSubscriptionActive(billing) ? (
      activeSubscriptionBillingInfo
    ) : billing.storeBillingStatus === STORE_BILLING_STATUS.GRACE_PERIOD ? (
      gracePeriodBillingInfo
    ) : billing.storeBillingStatus === STORE_BILLING_STATUS.ADMIN_GRANT ? (
      adminGrantedFreeMonthsBillingInfo
    ) : billing.storeBillingStatus ===
      STORE_BILLING_STATUS.SERVICE_SUSPENDED ? (
      serviceSuspendedBillingInfo
    ) : (
      <></>
    );
  };

  return (
    <>
      <Row className="m-0 d-flex justify-content-center w-100 ">
        <Col md={11}>
          <Topbar title="Billing (Subscription)"></Topbar>
        </Col>
      </Row>
      <Row className=" d-flex justify-content-center align-items-center">
        <Col md={11}>
          <Col
            md={4}
            className="d-flex flex-column justify-content-center align-items-center billing-card-wrapper gap-2"
          >
            <div className="billing-card-price-wrapper">
              <span></span>
              <span className="text-center">
                Subscription Status:{" "}
                <strong>{billing.storeBillingStatus}</strong>
                <br />
                <BillingStatusInfo />
              </span>
            </div>

            <>
              <div className="billing-card-price-wrapper">
                <span>
                  $
                  {parseToThousandSeperatorDecimalNumber(
                    currentStore?.billingAmount || 0
                  )}
                </span>
                <span>
                  per <br />
                  {currentStore?.billingType ===
                  storeConstants.BILLING_TYPE[0].value
                    ? "month"
                    : "year"}
                </span>
              </div>
              <Button
                type="button"
                label={buttonNameConstants.SUBSCRIBE}
                className={"w-100 mt-2"}
                handleClick={() => handleSubscriptionButtonClick()}
                isDisabled={
                  billing.storeBillingStatus ===
                  STORE_BILLING_STATUS.ACTIVE_SUBSCRIPTION
                }
              />
              <div className="payments-methods-wrapper">
                <span className="paymnet-mmethod-heading">
                  Supported payment methods:
                </span>
                <img src={PaymentMethods} alt="" />
              </div>
            </>
          </Col>
        </Col>
      </Row>
    </>
  );
};

// reducer
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(Billing);
